import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import InputText from "../../../components/Forms/Element/InputText";
import InputDecimal from "../../../components/Forms/Element/InputDecimal";
import StatusCheckBox from "../../../components/Common/StatusCheckbox";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { convertStatusToBoolean } from "../../../../utils/ConverterUtils";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import FormSection from "../../../components/Common/Form/FormSection";
import HintTooltip from "../../../components/Common/HintTooltip";

const Form = (props) => {
    const { t } = useTranslation();
    const { status, setStatus, formik, entityData } = props;

    useEffect(() => {
        // Preenche os valores nos campos.
        if (entityData != null) {
            formik.setFieldValue('name', entityData.name);
            formik.setFieldValue('creditFeePercentage', entityData.creditFeePercentage ?? '');
            formik.setFieldValue('debitFeePercentage', entityData.debitFeePercentage ?? '');
            formik.setFieldValue('pixFeePercentage', entityData.pixFeePercentage ?? '');
            setStatus(convertStatusToBoolean(entityData.status));
        }

        // eslint-disable-next-line
    }, [entityData]);

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description={t('card_flag_basic_information_hint')}
                    icon="fa-solid fa-credit-card"
                >
                    <Row className="g-3">
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>{t('name')} <AsteriskRequired /></FormLabel>
                                <InputText
                                    name="name"
                                    placeholder={t('card_flag_name_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                    error={formik.errors.name}
                                    maxlenght="50"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>
                                    {t('card_flag_credit_fee_percentage')} <HintTooltip text={t('card_flag_fee_percentage_hint')} />
                                </FormLabel>
                                <InputDecimal
                                    name="creditFeePercentage"
                                    placeholder={t('card_flag_fee_percentage_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.creditFeePercentage}
                                    error={formik.errors.creditFeePercentage}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>
                                    {t('card_flag_debit_fee_percentage')} <HintTooltip text={t('card_flag_fee_percentage_hint')} />
                                </FormLabel>
                                <InputDecimal
                                    name="debitFeePercentage"
                                    placeholder={t('card_flag_fee_percentage_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.debitFeePercentage}
                                    error={formik.errors.debitFeePercentage}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <FormLabel>
                                    {t('card_flag_pix_fee_percentage')} <HintTooltip text={t('card_flag_fee_percentage_hint')} />
                                </FormLabel>
                                <InputDecimal
                                    name="pixFeePercentage"
                                    placeholder={t('card_flag_fee_percentage_placeholder')}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.pixFeePercentage}
                                    error={formik.errors.pixFeePercentage}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('status')}
                    description={t('card_flag_status_hint')}
                    icon="fa-solid fa-toggle-on"
                    compact
                >
                    <Row>
                        <Col md={12}>
                            <FormGroup className="mb-0">
                                <StatusCheckBox
                                    name="status"
                                    defaultChecked={status}
                                    checked={status}
                                    onClick={() => setStatus(!status)} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
